import React, { useEffect, useState } from 'react'
import { Row, Col, RadioGroup, Radio } from 'rsuite'
import { requiredFiled, isValidators } from '../../../utils/ValidatorUtils'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import InputForm from './InputForm'

export default function InputRadioForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  index,
  onChange = () => {},
  ...props
}) {
  const keyName = props?.name || schema?.name
  const labelMdLg = props.labelMdLg || 24
  const inputMdlg = props.inputMdlg || 24
  const disabled = props.disabled || schema.disabled || false
  const [inputValue, setInputValue] = useState(props.value || schema?.value || '')
  const inline = props.inline || schema?.inline
  const options = props.options || schema?.options || schema?.inputOptions || []

  useEffect(() => {
    setInputValue(props.value || schema?.value || '')
  }, [props.value, schema])

  return (
    <>
      {schema && (
        <Row style={{ ...props.style }}>
          {errors[keyName] && (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[keyName]} />
            </Col>
          )}

          {!props.hideLabel && schema.label && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <p style={{ fontWeight: schema.isBolder ? 'bolder' : undefined }}>
                {requiredFiled(schema.validators, `${schema.label} ${index || ''}`)}
              </p>
            </Col>
          )}
          {schema.description && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <CustomIconMessageInfo style={{ marginBottom: 10 }} contents={schema.description} />
            </Col>
          )}
          <Col xs={24} sm={24} md={inputMdlg} lg={inputMdlg} style={{ marginTop: 5 }}>
            <Controller
              key={keyName}
              name={keyName}
              control={control}
              rules={isValidators(schema.validators)}
              defaultValue={inputValue}
              render={(props) => {
                return (
                  <>
                    <RadioGroup
                      inline={inline}
                      name={keyName}
                      value={inputValue}
                      onChange={(value) => {
                        props.onChange(value)
                        setInputValue(value)
                        onChange(value)
                      }}
                    >
                      {options?.map((item) => {
                        return (
                          <Radio value={item.value} disabled={item.disabled || disabled}>
                            {item.label}
                            {item.value == inputValue && (
                              <>
                                {item?.moreInputs?.map((e) => {
                                  if (e.type == '3') {
                                    return (
                                      <InputForm
                                        schema={e}
                                        register={register}
                                        Controller={Controller}
                                        control={control}
                                        errors={errors}
                                        setValue={setValue}
                                        clearErrors={clearErrors}
                                        rows={4}
                                        componentClass={'textarea'}
                                      />
                                    )
                                  } else {
                                    return (
                                      <InputForm
                                        schema={e}
                                        register={register}
                                        Controller={Controller}
                                        control={control}
                                        errors={errors}
                                        setValue={setValue}
                                        clearErrors={clearErrors}
                                        isInputNumber={e.type == '1'}
                                      />
                                    )
                                  }
                                })}
                              </>
                            )}
                          </Radio>
                        )
                      })}
                    </RadioGroup>
                  </>
                )
              }}
            />
          </Col>
        </Row>
      )}
    </>
  )
}
